import * as Sentry from "@sentry/react"
import { OglFluidBackground } from "@/components/background/OglFluidBackground"
import { Layout } from "@/components/layout/Layout"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "lenis/dist/lenis.css"
import "./index.css"

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    // Replay is added lazily after page load — rrweb patches DOM event listeners
    // on init which interferes with Lenis's wheel event handling on first paint.
  ],
  tracesSampleRate: 0.05,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

// Add Replay after the page is interactive so rrweb doesn't race with Lenis init
window.addEventListener("load", () => {
  requestIdleCallback(
    () => { Sentry.addIntegration(Sentry.replayIntegration()) },
    { timeout: 5000 },
  )
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <OglFluidBackground />
      <Layout />
    </QueryClientProvider>
  </StrictMode>,
)
